import React from 'react';
import { Link } from 'react-router-dom';
import { withMedia } from 'react-media-query-hoc';

import Logo from '../assets/Logo';
import Glyph from '../assets/Glyph';
import './Header.css';

export default withMedia(function (props) {
  return (
    <header>
      <div className="container">
      { props.media.mobile ? <div className="glyph"><Glyph/> </div>: <div className="logo"><Logo/></div> }
        <nav>
          <ul className="nav-list">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/charities">For charities</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
})



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js